/**
 * Push a conversion event to GTM's dataLayer so GTM can fire GA4 conversion
 * tags (key conversions are replicated to GA4 — global analytics rule). GTM
 * is loaded in app/layout.tsx but does NOT auto-mirror PostHog events, so key
 * conversions must be pushed explicitly. Gated by NEXT_PUBLIC_ANALYTICS_ENABLED;
 * GTM's own Consent Mode v2 setup decides ad/analytics storage. Use ONLY for
 * key conversions — funnel-step events stay PostHog-only.
 */
type DataLayerEvent = Record<string, unknown> & { event: string }

export function pushDataLayer(payload: DataLayerEvent): void {
  if (typeof window === "undefined") return
  if (process.env.NEXT_PUBLIC_ANALYTICS_ENABLED !== "true") return
  const w = window as unknown as { dataLayer?: unknown[] }
  w.dataLayer = w.dataLayer ?? []
  w.dataLayer.push(payload)
}
